export default __webpack_public_path__ + "static/assets/85272c074d713fff1e9d4f4931ecec36.png";